export default __webpack_public_path__ + "static/BgImg05-909a0041ee41f2fe498bb124d83a5f39.webp";